import * as Yup from 'yup';
import { USER_TAGS_KEYS } from 'shared/constants';
import { currentEnvironment } from 'shared/services/Environment';
import { ENVIRONMENT_KEYS } from 'shared/constants/environment';
import { isAppUrl } from 'shared/utils';

/** The backend's error code for an external link another item of the org already has. */
export const DUPLICATE_LINK_ERROR_CODE = 'DUPLICATE_EXTERNAL_LINK';

export const getKnowledgeItemSchema = ({ langEditor }) =>
  Yup.object().shape({
    title: Yup.string().min(2, 'Too Short!').max(200, 'Too Long!').required('Required!'),
    subtitle: Yup.string().max(150, 'Too Long!'),
    /*
    Localhost urls are not considered valid by yup,
    and this issue locks the save button when running the app in localhost
    https://github.com/jquense/yup/issues/224
  */
    // Duplicate links are the server's call (409 on save), not a client-side list scan.
    link:
      currentEnvironment() === ENVIRONMENT_KEYS.DEVELOPMENT
        ? Yup.string()
        : Yup.string()
            .url()
            .test('not-c8health-domain', 'Links to c8health domains are not allowed', value => {
              if (!value) return true;
              return !isAppUrl(value);
            }),
    keywords: Yup.array().of(Yup.string()),
    expiresAt: Yup.date().nullable(true),
    fileUpdatedAt: Yup.date().required('Required'),
    ownerIds: Yup.array()
      .of(Yup.string())
      .min(1, 'Please assign at least one owner')
      .required('Required!'),
    specialty: Yup.string().nullable(),
    subspecialty: Yup.string().nullable(),
    contentType: Yup.string().nullable(),
    targetAudience: Yup.array().of(Yup.string()).nullable(),
    labels: Yup.array().of(Yup.string()),
    type: Yup.string(),
    recipientsTags: Yup.object().shape({
      [USER_TAGS_KEYS.DEPARTMENT]: Yup.array().of(Yup.string()),
      [USER_TAGS_KEYS.ROTATION]: Yup.array().of(Yup.string()),
      [USER_TAGS_KEYS.ROLE]: Yup.array().of(Yup.string()),
      [USER_TAGS_KEYS.LEVEL_OF_TRAINING]: Yup.array().of(Yup.string()),
      [USER_TAGS_KEYS.PROFESSION]: Yup.array().of(Yup.string()),
      [USER_TAGS_KEYS.USERS]: Yup.array().of(Yup.string()),
    }),
    contributors: Yup.array().of(
      Yup.object().shape({
        userId: Yup.string(),
        contributorId: Yup.string(),
        displayName: Yup.string().max(50).required('Required!'),
      }),
    ),
    shareToHub: Yup.boolean(),
  });
